module.exports = "https://cdn.dove.it/_next/static/public/assets/agent-showing-house.6c9aeb89fd1888e255cb8a251a66174b.jpg";